import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'

export default function Gallery() {
  const [ready, setReady] = useState(false)

  // Centralize your items so rendering stays DRY
  const items = useMemo(
    () => [
      { year: 2008, src: '2008-main.jpg' },
      { year: 2009, src: '2009-main.jpg' },
      { year: 2012, src: '2012-main.jpg' },
      { year: 2013, src: '2013-main.jpg' },
      { year: 2014, src: '2014-main.jpg' },
      { year: 2015, src: '2015-main.jpg' },
      { year: 2019, src: '2019-main.jpg' },
      { year: 2022, src: '2022-main.jpg' }
    ],
    []
  )

  // Preload images before showing the gallery
  useEffect(() => {
    let cancelled = false

    const preload = src =>
      new Promise(resolve => {
        const img = new Image()
        img.onload = () => resolve(true)
        // resolve on error too so UI isn't blocked forever
        img.onerror = () => resolve(false)
        img.src = src
      })

    ;(async () => {
      await Promise.all(items.map(it => preload(it.src)))
      if (!cancelled) setReady(true)
    })()

    return () => {
      cancelled = true
    }
  }, [items])

  // While images load, show a centered loader and keep the page content hidden
  if (!ready) {
    return (
      <div
        className='d-flex align-items-center justify-content-center'
        style={{ minHeight: '50vh' }}
      >
        {/* Bootstrap spinner (or swap for your own) */}
        <div className='text-center'>
          <div className='spinner-border' role='status' aria-label='Loading' />
          <div className='mt-3'>Loading gallery…</div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className='container my-5'>
        <div className='row'>
          {items.map(({ year, src }) => (
            <div key={year} className='col-lg-4 col-md-4 p-3'>
              <div className='gallery-main-box'>
                <Link to={`/${year}`}>
                  <img
                    src={src}
                    alt={`${year} gallery cover`}
                    loading='lazy'
                    className='img-fluid'
                  />
                  <h4 className='mt-2'>{year}</h4>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
